import { getApiUrl, AXIOS_AUTHED, getAxiosInstanceByLoginMode } from './shared';
import { isStringNumber, serializeAsQueryString } from '../../utils/utils';
import { constructPageString } from '../../utils/api-util';
import { DEFAULT_PAGEABLE } from './shared';

const count = (criteria) => {
  return getAxiosInstanceByLoginMode().get(
    `${getApiUrl()}/orders/count?${buildQueryString(criteria)}`
  );
};

const get = (criteria) => {
  return AXIOS_AUTHED.get(
    `${getApiUrl()}/orders?${buildQueryString(criteria)}`
  );
};

const getById = (id) => {
  return AXIOS_AUTHED.get(`${getApiUrl()}/orders/${id}`);
};

const getByCustomer = (customer, pageable = DEFAULT_PAGEABLE) => {
  const pageString = constructPageString(pageable);
  const queryString = serializeAsQueryString({
    customerIds: customer.billToCustomerId
  });
  return AXIOS_AUTHED.get(`${getApiUrl()}/orders?${pageString}&${queryString}`);
};

const create = (customer) => {
  return AXIOS_AUTHED.post(`${getApiUrl()}/orders`, {
    mrsOrderId: buildOrderId(customer),
    branchId: customer.branchId,
    routeNumber: customer.routeNumber,
    customerId: customer.billToCustomerId,
    customerName: customer.billToCustomerName,
    customerNumber: customer.billToCustomerNumber
  });
};

const update = (order, lineItems) => {
  return AXIOS_AUTHED.put(`${getApiUrl()}/orders`, {
    ...order,
    lineItems: lineItems
  });
};

const submit = (order, action = 'ACCEPT') => {
  return AXIOS_AUTHED.post(`${getApiUrl()}/orders/workflow-request`, {
    mrsOrderId: order.mrsOrderId,
    action
  });
};

const deleteRecord = (order, action = 'DELETE') => {
  return AXIOS_AUTHED.post(`${getApiUrl()}/orders/workflow-request`, {
    mrsOrderId: order.mrsOrderId,
    action
  });
};

const buildOrderId = (customer) => {
  return `${customer.billToCustomerId}:${Date.now()}`;
};

const buildQueryString = (criteria) => {
  const key = isStringNumber(criteria.search)
    ? 'customerNumbers'
    : 'customerName';
  return serializeAsQueryString(
    {
      ...criteria,
      search: undefined, // delete this one
      [key]: criteria.search
    },
    true
  );
};

export { get, getById, getByCustomer, create, update, submit, count, deleteRecord };
